import React from 'react';
import { defineMessages } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import BaseModal from '@components/common/form/BaseModal';
import ListPage from '@components/common/layout/ListPage';
import PageWrapper from '@components/common/layout/PageWrapper';
import { DEFAULT_TABLE_ITEM_SIZE } from '@constants';
import apiConfig from '@constants/apiConfig';
import useListModal from '@hooks/useListModal';
import useTranslate from '@hooks/useTranslate';
import { BaseTable } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { Button, Flex, Form } from 'antd';

import EmployeeForm from './EmployeeForm';

const message = defineMessages({
    objectName: 'Employee',
});

const EmployeeListPage = () => {
    const translate = useTranslate();
    const navigate = useNavigate();

    const {
        data,
        mixinFuncs,
        queryFilter,
        detail,
        setDetail,
        loading,
        pagination,
        titleModal,
        executeSave,
        loadingSave,
        openModal,
        onShowModal,
        onCancelModal,
        form,
        isEditing,
        onSave,
    } = useListModal({
        apiConfig: apiConfig.employee,
        options: {
            pageSize: DEFAULT_TABLE_ITEM_SIZE,
            objectName: translate.formatMessage(message.objectName),
        },
        override: (funcs) => {
            funcs.mappingData = (response) => {
                if (response.result === true) {
                    return {
                        data: response.data.content,
                        total: response.data.totalElements,
                    };
                }
            };
        },
    });

    const columns = [
        {
            title: translate.formatMessage(commonMessage.name),
            dataIndex: 'employeeName',
        },
        mixinFuncs.renderStatusColumn({ width: '120px' }),
        mixinFuncs.renderActionColumn(
            {
                edit: true,
                delete: true,
            },
            { width: '120px' },
        ),
    ];

    const searchFields = [
        {
            key: 'employeeName',
            placeholder: translate.formatMessage(commonMessage.name),
        },
    ];

    const handleOpenCreateModal = () => {
        setDetail(null);
        form.resetFields();
        onShowModal();
    };

    return (
        <PageWrapper routes={[ { breadcrumbName: translate.formatMessage(message.objectName) } ]}>
            <ListPage
                searchForm={mixinFuncs.renderSearchForm({ fields: searchFields, initialValues: queryFilter })}
                actionBar={
                    <Flex justify="end">
                        <Button type="primary" onClick={handleOpenCreateModal}>
                            <PlusOutlined />
                        </Button>
                    </Flex>
                    
                }
                baseTable={
                    <BaseTable
                        onChange={mixinFuncs.changePagination}
                        columns={columns}
                        dataSource={data}
                        pagination={pagination}
                        style={{ cursor: 'pointer' }}
                        loading={loading || loadingSave}
                    />
                }
            />
            {openModal && (
                <BaseModal
                    isModalVisible={openModal}
                    handleCancel={onCancelModal}
                    title={titleModal}
                    form={form}
                    onDelete={detail ? () => mixinFuncs.handleDelete(detail.id) : null}
                    isEditing={isEditing}
                    width="750px"
                    loading={loadingSave}
                >
                    <EmployeeForm
                        detail={detail}
                        form={form}
                        onCancel={onCancelModal}
                        isEditing={isEditing}
                        mixinFuncs={mixinFuncs}
                        executeSave={executeSave}
                        onSave={onSave}
                        loadingSave={loadingSave}
                    />
                </BaseModal>
            )}
        </PageWrapper>
    );
};

export default EmployeeListPage;
